import React from 'react';
import MoreInfo from '../components/MoreInfo';
import insitu_icon from '../assets/icons/INSITU-gold.svg';
import sky_particle from '../assets/img/sky_particles.png';
import '../styles/technology.css'

const Technology = () => {
    return (
        <div className="technology">
            <div className="technology-intro">
                <div className="technology-intro-description">
                    <img src={insitu_icon} alt="Title Insitu360" className='technology-intro-img' />
                    <p className='technology-intro-text-bold'><span className='color'>Insitu360™</span> is a new advanced technology for improving the efficacy of multiple molecules in a system by one step process consist of extraction, complexation and purification.  </p>
                    <p className='technology-intro-text grey'>
                        The technology ensures and focuses on the synergism of the bioactive ingredients incorporated instead of the pharmacological effects of the individual ingredients.
                        <br /><br />
                        The synergistic action of the ingredients together with the tailored technology ensures a product with enhanced bioefficacy.
                    </p>
                </div>
                <div className="technology-intro-details">
                    <h1 className='technology-intro-details-title color'>insitu360™ <br />technology <br /><span className='white'>& testolift™ ?</span></h1>
                    <p className='technology-intro-details-text grey'><span className='color bold uppercase'>Insitu360™</span> is a proprietary, multi-functional processing platform designed to maximize the
                        efficacy, bioavailability, and synergy of plant-based bioactives. <br /><br />
                        It involves a single-step process that includes:
                    </p>
                    <div className='technology-intro-details-container-step'>
                        <div className="technology-intro-step">
                            <h3 className='technology-intro-step-title color uppercase'>Extraction</h3>
                            <p className='technology-intro-details-step-text grey'>Pulling out active compounds using optimized solvents and conditions.</p>
                        </div>
                        <div className='horizontal-bar'></div>
                        <div className="technology-intro-step">
                            <h3 className='technology-intro-step-title color uppercase'>purification</h3>
                            <p className='technology-intro-details-step-text grey'>Removing unwanted substances to concentrate and preserve the active forms.</p>
                        </div>
                        <div className='horizontal-bar'></div>
                        <div className="technology-intro-step">
                            <h3 className='technology-intro-step-title color uppercase'>Complexation</h3>
                            <p className='technology-intro-details-step-text grey'>
                                Molecular Binding of bioactive molecules (like cyclodextrins or phospholipids) to improve solubility and stability.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="technology-synergy">
                <h2 className="technology-synergy-title">How It Enhances Synergy Between <br/><span className='color'>Fenugreek & Black Ginger</span></h2>
                <p className="technology-synergy-description">
                    The combination of these two herbs becomes more potent <br /> and efficient when processed via insitu360™, due to:
                </p>
                <div className="technology-synergy-list">
                    <div className="technology-synergy-item">
                        <p className="technology-synergy-item-number">01.</p>
                        <h4 className='technology-synergy-item-title color'>Enhanced<br /> Bioavailability<br /> of Actives</h4>
                        <p className='grey'>
                            Fenugreek's Protodioscin and black ginger’s methoxyflavones are poorly water-soluble.
                            <br /><br />
                            Insitu360™ helps to encapsulate or bind these molecules with solubilizing agents, improving
                            absorption in the gut.
                        </p>
                        <br />
                        <p>
                            Result: More active compounds reach the bloodstream, increasing effectiveness.
                        </p>
                    </div>
                    <div className="technology-synergy-item">
                        <p className="technology-synergy-item-number">02.</p>
                        <h3 className='technology-synergy-item-title color'>Molecular <br />Level<br /> Compatibility</h3>
                        <p className='grey'>
                            Insitu360™ ensures that fenugreek’s hormone-modulating effects (via enzyme inhibition and
                            LH stimulation) work in concert with black ginger’s vasodilatory and metabolic effects.
                            <br /><br />
                            These mechanisms don’t overlap but complement each other, creating a multi-angle testosterone support system:
                        </p>
                        <br />
                        <p>Fenugreek = boosts testosterone production directly.</p>
                        <p>Black Ginger = enhances the body’s physiological environment to support and utilize that testosterone.</p>
                    </div>
                    <div className="technology-synergy-item">
                        <p className="technology-synergy-item-number">03.</p>
                        <h3 className='technology-synergy-item-title color'>stability<br />& sustained <br />release</h3>
                        <p className='grey'>The complexation process helps protect sensitive compounds (like Protodioscin or flavonoids) from degradation during digestion or storage.</p><br/>
                        <p>Allows for slower, sustained release — maintaining consistent blood levels over time.</p>
                    </div>
                    <div className="technology-synergy-item">
                        <p className="technology-synergy-item-number">04.</p>
                        <h3 className='technology-synergy-item-title color'>Reduced<br /> Interference<br /> & Maximum Utilization</h3>
                        <p className='grey'>
                            Traditional formulations may suffer from bioactive interference—one herb can reduce the
                            absorption or function of another.
                        </p>
                        <br/>
                        <p>
                            <span className='bold uppercase'>Insitu360™</span> helps in molecular stabilization and spatial orientation, allowing both herbal
                            components to work simultaneously without antagonizing each other.
                        </p>
                    </div>
                </div>
            </div>
            <div className="technology-benefit">
                <div className="technology-benefit-wrapper">
                    <img className="technology-benefit-img" src={sky_particle} alt="" />
                    <div className="technology-benefit-content">
                        <h3 className='technology-benefit-title color'>Real-World Benefit</h3>
                        <p className="technology-benefit-description">
                            Without <span className='color bold uppercase'>Insitu360™</span>, your body might absorb only 20-30% of the key compounds. With it, you
                            could see absorption efficiency rise significantly — sometimes 2x or 3x higher — translating
                            to <span className='color'>greater testosterone support, quicker results, and better consistency.</span>
                        </p>
                        <br/>
                        <div className="technology-benefit-subblock">
                            <div className="technology-benefit-subblock-left">
                                <div className="technology-benefit-subblock-line">
                                    <p className="technology-benefit-subblock-text">Conclusion: The Synergistic Power of Testolift™ with <span className='uppercase color'>Insitu360™</span> Technology stands out as a next-generation testosterone-boosting nutraceutical by combining
                                        fenugreek and black ginger — two powerful, clinically backed herbs — with the advanced
                                        delivery and enhancement system of Insitu360™ Technology.
                                    </p>
                                </div>
                                <br/>
                                <p className="technology-benefit-subblock-description grey">
                                    This unique formulation not only targets testosterone production directly through enzyme
                                    inhibition and hormonal stimulation (via fenugreek) but also optimizes the body's
                                    environment for testosterone function through improved circulation, metabolic support, and
                                    erectile function (via black ginger).
                                </p>
                            </div>
                            <div className="technology-benefit-subblock-right">
                                <ul className="technology-benefit-list">
                                    <h4 className='technology-benefit-list-title color'>Thanks to insitu360™, <br /> these bioactives are:</h4>
                                    <li className='technology-benefit-list-item grey'>More bioavailable</li>
                                    <li className='technology-benefit-list-item grey'>Better absorbed and utilized</li>
                                    <li className='technology-benefit-list-item grey'>Stabilized for consistent, sustained action</li>
                                    <li className='technology-benefit-list-item grey'>Optimized for synergistic, non-competing activity</li>
                                </ul>
                            </div>
                        </div>
                        <div className="technology-benefit-final">
                            <p className="technology-benefit-final-text">Together, this creates a holistic, potent, and scientifically smart approach to naturally
                                enhancing testosterone levels and male vitality — making Testolift™ a standout enhance in
                                the nutraceutical space.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <MoreInfo />
        </div>
    );
};

export default Technology;
